import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import {Box, Grid, Button, Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';
import {Paper, IconButton, Menu, MenuItem, ListItemIcon, ListItemText} from '@material-ui/core';
import {TextField, Select} from '@material-ui/core';
import MoreVert from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
//import { sortByLogin } from '../../../api/helpers';

class DispatchersListEditor_ extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            menuAnchor: null,
            dispatcherFilter: ''
        }

        this.handleFilterInput = this.handleFilterInput.bind(this)
        this.handlePasswordPolicy = this.handlePasswordPolicy.bind(this)
    }

    handleDispatcherSelect(dispatcherID){
        this.props.onDispatcherSelect(dispatcherID)
    }

    getDispatcherStyle(dispatcherID){
        let selected = dispatcherID === this.props.selectedDispatcherID
        let style = {
            background: selected? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }

    handleMenuClick(event, itemID){
        this.setState({menuAnchor: event.currentTarget, menuItemID: itemID});
        event.stopPropagation();
    }

    handleMenuClose(){
        this.menuAnchor = null;
        this.setState({menuAnchor: null});
        return null;
    }

    handleMenuItemClick(action, dispatcherID){
        this.handleMenuClose();
        this.props.onAction({type: action, dispatcherID: dispatcherID})
    }   

    handleFilterInput(event){
        const val =  event.target.value
        this.setState({dispatcherFilter: val})
    }

    handlePasswordPolicy(){
        this.props.onAction({type:'SHOW_PASSWORD_POLICY_DIALOG'})
    }

    render(){

        console.log('render DispatchersListEditor')
        console.log(this.props)

        const {t} = this.props

        let dispatchers = [];
        if(this.props.dispatchers){
            //this.props.dispatchers.sort(sortByLogin)

            if(this.state.dispatcherFilter){
                var filter = this.state.dispatcherFilter.toLowerCase()
                dispatchers = this.props.dispatchers.filter(
                    (item) => { 
                        const pos = item.DispatcherData.Name.toLowerCase().indexOf(filter)
                        const pos2 = item.DispatcherData.Login.toLowerCase().indexOf(filter)
                        return pos>=0 || pos2>=0
                    }
                )

            }else{
                dispatchers = this.props.dispatchers
            }
            

        }else{
            return '';
        }
        console.log('render this.props.dispatchers')
        console.log(this.props.dispatchers)



        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            addIcon: {
                color: 'white'
            }
        };

        return(
            <>

                    <Box>
                        <Grid container>
                            <Grid item xs={6} align="left">

                                <TextField name="dispatcherFilter"
                                    margin='normal'
                                    variant2="outlined"
                                    size="small"
                                    style={{width: '100%'}}
                                    label={t('FilterDispatchers')}
                                    autoComplete="new-password"
                                    error={false}
                                    value={this.state.dispatcherFilter}
                                    onChange={this.handleFilterInput}
                                />
                            </Grid>
                            <Grid item xs={6} align="right">
                                <Button variant='outlined' style={{margin:15}} onClick={this.handlePasswordPolicy} >{t('PasswordPolicy')}</Button>
                            </Grid>
                        </Grid>
                    </Box>

                <Paper style={styles.paper}>    

                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell style={styles.head}>{t('Login')}</TableCell>
                                <TableCell style={styles.head}>{t('Name')}</TableCell>
                                <TableCell style={styles.head}>{t('Priority')}</TableCell>
                                <TableCell style={{...styles.head, width:40}}>
                                    <IconButton size="small" color="primary" aria-label="more" component="span"
                                        style={styles.addIcon}
                                        onClick={()=>{this.handleMenuItemClick('DISPATCHER_EDITOR_OPEN_ADD')}}>
                                        <AddCircleOutlineIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {dispatchers.map((dispatcher) => 
                            <TableRow key={dispatcher.DispatcherData.ID} 
                                    onClick={()=>{this.handleDispatcherSelect(dispatcher.DispatcherData.ID)}}
                                    onDoubleClick={()=>{this.handleMenuItemClick('DISPATCHER_EDITOR_OPEN_EDIT', dispatcher.DispatcherData.ID)}}
                                    style={this.getDispatcherStyle(dispatcher.DispatcherData.ID)}>
                                <TableCell component="th" scope="row">
                                    {dispatcher.DispatcherData.Login}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {dispatcher.DispatcherData.Name}
                                </TableCell>
                                <TableCell style={{width:50, whiteSpace:'nowrap'}}>
                                    <Select
                                        value={dispatcher.DispatcherData.Priority}
                                        onChange={event=>{
                                            this.props.onAction({
                                                type: 'DISPATCHER_EDITOR_INPUT', 
                                                event: event, 
                                                dispatcherID: dispatcher.DispatcherData.ID})
                                        }}
                                        inputProps={{
                                            name: 'Priority',
                                            id: 'Priority',
                                        }}
                                        >
                                        <MenuItem key="14" value={14}>+14</MenuItem>
                                        <MenuItem key="13" value={13}>+13</MenuItem>
                                        <MenuItem key="12" value={12}>+12</MenuItem>
                                        <MenuItem key="11" value={11}>+11</MenuItem>
                                        <MenuItem key="10" value={10}>+10</MenuItem>
                                        <MenuItem key="9" value={9}>+9</MenuItem>
                                        <MenuItem key="8" value={8}>+8</MenuItem>
                                        <MenuItem key="7" value={7}>+7</MenuItem>
                                        <MenuItem key="6" value={6}>+6</MenuItem>
                                        <MenuItem key="5" value={5}>+5</MenuItem>
                                        <MenuItem key="4" value={4}>+4</MenuItem>
                                        <MenuItem key="3" value={3}>+3</MenuItem>
                                        <MenuItem key="2" value={2}>+2</MenuItem>
                                        <MenuItem key="1" value={1}>+1</MenuItem>
                                        <MenuItem key="0" value={0}>{t('Default')}</MenuItem>
                                        <MenuItem key="-1" value={-1}>-1</MenuItem>
                                    </Select>
                                </TableCell>
                                <TableCell style={{width:40}}>
                                    <IconButton size="small" color="inherit" aria-label="add" component="span"
                                        onClick={event=>this.handleMenuClick(event, dispatcher.DispatcherData.ID)}>
                                        <MoreVert />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        )}
                        </TableBody>
                        <Menu anchorEl={this.state.menuAnchor} keepMounted
                            open={Boolean(this.state.menuAnchor)} onClose={this.handleMenuClose.bind(this)}>
                            <MenuItem onClick={()=>{this.handleMenuItemClick('DISPATCHER_EDITOR_OPEN_EDIT', this.state.menuItemID)}}>
                                <ListItemIcon color="primary"><EditIcon/></ListItemIcon> 
                                <ListItemText primary={t('EditDispatcher')+'...'} />
                            </MenuItem>
                            <MenuItem onClick={()=>{this.handleMenuItemClick('DISPATCHER_EDITOR_DELETE', this.state.menuItemID)}}>
                                <ListItemIcon><DeleteForeverIcon/></ListItemIcon>
                                <ListItemText primary={t('DeleteDispatcher')} />
                            </MenuItem>
                        </Menu>
                    </Table>
                </Paper>
            </>
        )

    }

}

export const DispatchersListEditor = withTranslation()(DispatchersListEditor_);